<template>
  <div v-if="canRegister" class="sf-container">
    <h1>
      Create a Mathsframe / Spellingframe account
    </h1>
    <div class="md:tw-grid md:tw-grid-cols-2 md:tw-gap-8 lg:tw-gap-16 tw-pt-16">
      <AccountTypeOptions type="individual" />
      <AccountTypeOptions type="school" />
    </div>
  </div>
  <div v-else-if="isMfUser">
    <p>
      If you want to register a new user independet from you mathsframe user
      first logout.
    </p>
    <p>
      Otherwise
      <SfRouterLink to="/dashboard">go to your dashboard</SfRouterLink>.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AccountTypeOptions from "./AccountTypeOptions.vue";
import userHasRole from "@/func/user/userHasRole";
import SfRouterLink from "../shared/SfRouterLink.vue";

export default defineComponent({
  components: { AccountTypeOptions, SfRouterLink },
  computed: {
    canRegister() {
      return this.$currentUser.value == null;
    },
    isMfUser() {
      return (
        this.$currentUser.value &&
        userHasRole(this.$currentUser.value, ["mfSchool", "mfIndividual"])
      );
    },
  },
});
</script>
